import { render, staticRenderFns } from "./report-tongue80.vue?vue&type=template&id=b9e1b6e8&scoped=true&"
import script from "./report-tongue80.vue?vue&type=script&lang=ts&"
export * from "./report-tongue80.vue?vue&type=script&lang=ts&"
import style0 from "./report-tongue80.vue?vue&type=style&index=0&id=b9e1b6e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e1b6e8",
  null
  
)

export default component.exports